import _ from 'lodash'
import { utils } from 'frontend-js-shared'

const { dates } = utils

export function getDateRangeText(dateRange = []) {
  if (_.isEmpty(dateRange)) return ''

  const [startDate, endDate] = dateRange

  return `${dates.formatDate(dates.getStartOfDay(startDate), 'MMM DD, YYYY')} - ${dates.formatDate(
    dates.getEndOfDay(endDate),
    'MMM DD, YYYY'
  )}`
}
